import { createSlice } from '@reduxjs/toolkit';
import { InternalApiCustomSchema } from '../api-internal';

export interface SchemaState {
  customPersonSchema: InternalApiCustomSchema | null;
}

const initialState: SchemaState = {
  customPersonSchema: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    fetchCustomPersonSchemaSuccess: (state, action) => {
      state.customPersonSchema = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = authSlice;
// Extract and export each action creator by name
export const { fetchCustomPersonSchemaSuccess } = actions;
// Export the reducer, either as a default or named export
export default reducer;
